import { useAuth } from "../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { MAP_VIEW_PATH, SEARCH_PATH, isGraphViewRoutePath } from "../constants/routes.js";
import { hasGraphViewPermissions } from "../utils/utils.jsx";

const Home = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (user && isAuthenticated) {
      const requestedPath = location.state?.from?.pathname;
      const hasGraphViewAccess = hasGraphViewPermissions(user?.role);
      const isBlockedGraphPath = requestedPath && isGraphViewRoutePath(requestedPath) && !hasGraphViewAccess;
      const from = requestedPath && requestedPath !== SEARCH_PATH && !isBlockedGraphPath ? requestedPath : MAP_VIEW_PATH;
      navigate(from, { replace: true });
    }
  }, [user, navigate, location, isAuthenticated]);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <CircularProgress size={28} thickness={4.5} />
    </div>
  );
};

export default Home;
